module.exports = __webpack_public_path__ + "img/horizontal_1_1_3009.ed602f1e.png";